import React from 'react';
import { Text, Title } from '../../../../components';
import { Accordion } from '../Accordion/Accordion';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FaqItem } from '../../../../types/globalTypes';
import {
  COLORS,
  CONTACT_US_FAQ,
  CONTACT_US_TITLE,
  device,
  FONTS,
  ROUTES,
} from '../../../../constants';
import { ContactIcon } from '../../../../assets/svg';
import { NavLink as Link } from 'react-router-dom';

interface FaqProps {
  faqs: FaqItem[];
}

const Faq = ({ faqs }: FaqProps) => {
  const { t } = useTranslation();
  return (
    <FaqWrapper>
      <Title title={t('screen.home.faq.title')} isAnimated={true} />
      <FaqContent>
        <Accordion faqs={faqs} />
        <FaqContact>
          <div>
            <ContactImage src={ContactIcon} />
            <Text
              text={CONTACT_US_FAQ}
              weight={600}
              size={24}
              lineHeight={30}
            />
          </div>
          <StyledLink to={ROUTES.CONTACT_US}>{CONTACT_US_TITLE}</StyledLink>
        </FaqContact>
      </FaqContent>
    </FaqWrapper>
  );
};
const FaqWrapper = styled.div`
  > span {
    margin-bottom: 60px;
    display: block;
  }
  @media screen and ${device.md} {
    > span {
      margin-bottom: 20px;
      font-size: 25px;
      line-height: 30px;
    }
  }
  @media screen and ${device.sm} {
    > span {
      margin-bottom: 0;
      font-size: 20px;
      line-height: 26px;
    }
  }
`;
const FaqContent = styled.div`
  display: flex;
  gap: 80px;
  justify-content: space-between;
  align-items: flex-start;
  @media screen and ${device.lg} {
    gap: 40px;
  }
  @media screen and ${device.md} {
    gap: 20px;
    flex-direction: column-reverse;
  }
`;
const FaqContact = styled.div`
  width: 390px;
  padding: 40px;
  box-sizing: border-box;
  border: 1px solid ${COLORS.BORDER_CARD};
  @media screen and ${device.xl} {
    width: 300px;
    padding: 20px;
  }
  @media screen and ${device.md} {
    display: flex;
    gap: 20px;
    width: 100%;
    align-items: center;
    h4 {
      font-size: 14px;
      line-height: 18px;
    }
    > div {
      display: flex;
      gap: 20px;
      align-items: center;
    }
    a {
      margin-top: 10px;
      height: 38px;
      gap: 0;
      padding: 0;
      font-size: 12px;
      line-height: 18px;
    }
  }
`;
const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  background-color: ${COLORS.MAIN_RED};
  color: ${COLORS.WHITE};
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  padding: 0;
  width: 100%;
  height: 55px;
  margin-top: 40px;
  font-family: ${FONTS.SUBTITLE};
  &:hover {
    background: ${COLORS.RED_HOVER};
  }
  &:active {
    background: ${COLORS.RED_PRESSED};
  }
  @media screen and ${device.sm} {
    font-size: 12px;
  }
`;
const ContactImage = styled.img`
  width: 120px;
  height: 105px;
  margin-bottom: 40px;
  @media screen and ${device.md} {
    width: 60px;
    height: 45px;
    margin-bottom: 10px;
  }
`;
export default Faq;
